import React from 'react'
import { useOnInputChange } from '../../hooks/useOnInputChange'
import { useAsyncOperation } from '../../hooks/useAsyncOperation'
import { AuthService } from '../../apilibrary'
import Box from '../../components/box'
import TextField from '../../components/textfield'
import Button from '../../components/button'
import Typography, { TypographyColor } from '../../components/typography'

interface NewPasswordRequiredFormProps {
  email: string
  cognitoUser: any
  onPasswordResetComplete: (newPassword: string) => Promise<void>
}

const NewPasswordRequiredForm: React.FC<NewPasswordRequiredFormProps> = ({
  email,
  cognitoUser,
  onPasswordResetComplete
}) => {
  const [newPassword, useOnChangeNewPassword] = useOnInputChange('')
  const [confirmNewPassword, useOnChangeConfirmNewPassword] = useOnInputChange('')
  const {
    runFunction: handleCompleteNewPassword,
    loading: loadingCompleteNewPassword
  } = useAsyncOperation(AuthService.completeNewPassword)
  const [errorMessage, setErrorMessage] = React.useState<string>()

  const handleClickResetPassword = async (): Promise<void> => {
    try {
      if (newPassword !== confirmNewPassword) {
        throw new Error('Passwords do not match')
      }
      await handleCompleteNewPassword({
        cognitoUser,
        newPassword
      })
      await onPasswordResetComplete(newPassword)
    } catch (error) {
      if (error instanceof Error) {
        setErrorMessage(error.message)
      } else {
        setErrorMessage('Something went wrong')
      }
    }
  }

  return (
    <Box>
      <Typography variant='h5' fontWeight={'bold'} color={TypographyColor.WARNING} gutterBottom>
        New Password Required
      </Typography>
      {errorMessage && (
        <Typography color={'error'}>
          {errorMessage}
        </Typography>
      )}
      <TextField fullWidth gutterBottom label="Email" value={email} disabled />
      <TextField
        fullWidth
        gutterBottom
        label="New Password"
        type="password"
        value={newPassword}
        onChange={useOnChangeNewPassword}
      />
      <TextField
        fullWidth
        gutterBottom
        label="Confirm New Password"
        type="password"
        value={confirmNewPassword}
        onChange={useOnChangeConfirmNewPassword}
      />
      <Button
        fullWidth
        variant='contained'
        sx={{ mt: 2 }}
        onClick={handleClickResetPassword}
        disabled={loadingCompleteNewPassword}
      >
        Reset Password
      </Button>
    </Box>
  )
}

export default NewPasswordRequiredForm
